import {
  ArchiveForumData,
  DynamicPage,
  ForumData,
  GalleryImage,
  News,
  Program,
  ProgramSection,
  SearchSuggestion,
  SignUpData,
  Speaker,
  YearTag
} from './models';


const programSections: ProgramSection[] = [
  {
    id: 1,
    name: 'Пленарные заседания',
    location: 'Выставочный зал',
    is_coffee_break: false,
    subject: 'Каждый ребенок достоин семьи. Планы, Перспективы и Проекты Фонда',
    date: '2021-09-10',
    start_at: '10:00',
    finish_at: '11:00',
    speakers: [{
      id: 12,
      full_name: 'Анастасия Залогина',
      organization: 'Президент фонда «Обнаженные сердца», Москва',
      image: '/speakers/speaker_avatar.png',
    },
    ],
  },
  {
    id: 2,
    name: '',
    location: 'Выставочный зал',
    is_coffee_break: true,
    subject: 'Кофебрейк',
    date: '2021-09-10',
    start_at: '11:00',
    finish_at: '12:00',
  },
  {
    id: 3,
    name: 'секция 1',
    location: 'Выставочный зал',
    is_coffee_break: false,
    subject: 'Особенности организации учебного процесса у детей с РАС в рамках инклюзивного образования',
    date: '2021-09-10',
    start_at: '12:00',
    finish_at: '18:00',

    description: 'Миссия «Обнаженных сердец» - помочь становлению общества, открытого к людям с особенностями, развивая системную профессиональную поддержку семьи и инклюзию в образовании, трудоустройстве и досуге.',
    files: [
      { title: 'Отчёт о результатах деятельности 2019 года', url: '/speakers/speaker_5.png' },
      { title: 'Отчёт о результатах деятельности 2020 года', url: '/speakers/speaker_4.png' },
    ],

    moderators: [{
      id: 21,
      full_name: 'Святослав Довбня и Татьяна Морозова',
      organization: 'Эксперты фонда «Обнажённые сердца», Санкт-Петербург',
      image: '/speakers/speaker_4.png',
    }],

    speakers: [{
      id: 5,
      full_name: 'Илья Чибисов',
      organization: 'Центр детсткой неврологии, Тула',
      image: '/speakers/speaker_5.png',
    }, {
      id: 4,
      full_name: 'Лейзл Шлебуш',
      organization: 'Университет Кейптауна, ЮАР',
      image: '/speakers/speaker_4.png',
    }, {
      id: 12,
      full_name: 'Анастасия Залогина',
      organization: 'Президент фонда «Обнаженные сердца», Москва',
      image: '/speakers/speaker_avatar.png',
    },
    ],
    speeches: [
      {
        id: 1,
        date: '2021-09-10',
        start_at: '12:00',
        finish_at: '13:00',
        subject: 'Каждый ребенок достоин семьи. Планы, Перспективы и Проекты Фонда',
        speakers: [{
          id: 12,
          full_name: 'Анастасия Залогина',
          organization: 'Президент фонда «Обнаженные сердца», Москва',
          image: '/speakers/speaker_avatar.png',
        },],
        moderators: [{
          id: 31,
          full_name: ' Татьяна Морозова',
          organization: 'клинический психолог, эксперт фонда «Обнажённые сердца», Санкт-Петербург'
        }],
      }, {
        id: 2,
        date: '2021-09-10',
        start_at: '13:00',
        finish_at: '17:15',
        subject: 'Какие программы помощи для детей с РАС и особенностями развития на сегодняшний день являются доказано эффективными',
        speakers: [{
          id: 4,
          full_name: 'Лейзл Шлебуш',
          organization: 'Университет Кейптауна, ЮАР',
          image: '/speakers/speaker_4.png',
        },],
      }, {
        id: 3,
        date: '2021-09-10',
        start_at: '17:15',
        finish_at: '18:00',
        subject: 'Кофебрейк',
      },],
  },
  {
    id: 4,
    name: 'секция 2',
    location: 'Выставочный зал',
    is_coffee_break: false,
    subject: 'Проект А-ТЕСН: программа поддержки и обучения семей с детьми с тяжелыми двигательными и множественными нарушениями развития. Опыт разработки проекта совместной с родителями',
    date: '2021-09-10',
    start_at: '15:00',
    finish_at: '18:00',

    speakers: [{
      id: 5,
      full_name: 'Илья Чибисов',
      organization: 'Центр детсткой неврологии, Тула',
      image: '/speakers/speaker_5.png',
    }],
  },
  // {
  //   id: 124,
  //   name: 'секция 124',
  //   location: 'Выставочный зал',
  //   subject: 'Проект А-ТЕСН: программа поддержки и обучения семей с детьми с тяжелыми двигательными и множественными нарушениями развития. Опыт разработки проекта совместной с родителями',
  //   date: '2021-09-10',
  //   start_at: '16:20',
  //   finish_at: '17:00',
  //
  //   speakers: [{
  //     id: 5,
  //     name: 'Илья Чибисов',
  //     organization: 'Центр детсткой неврологии, Тула',
  //     image: '/speakers/speaker_5.png',
  //   }],
  // },
  // {
  //   id: 42,
  //   name: 'секция 42',
  //   location: 'Выставочный зал',
  //   subject: 'Проект А-ТЕСН: программа поддержки и обучения семей с детьми с тяжелыми двигательными и множественными нарушениями развития. Опыт разработки проекта совместной с родителями',
  //   date: '2021-09-10',
  //   start_at: '15:10',
  //   finish_at: '16:50',
  //
  //   speakers: [{
  //     id: 5,
  //     name: 'Илья Чибисов',
  //     organization: 'Центр детсткой неврологии, Тула',
  //     image: '/speakers/speaker_5.png',
  //   }],
  // },
  // {
  //   id: 88,
  //   name: 'секция 88',
  //   location: 'Выставочный зал',
  //   subject: 'Проект А-ТЕСН: программа поддержки и обучения семей с детьми с тяжелыми двигательными и множественными нарушениями развития. Опыт разработки проекта совместной с родителями',
  //   date: '2021-09-10',
  //   start_at: '16:10',
  //   finish_at: '17:50',
  //
  //   speakers: [{
  //     id: 5,
  //     name: 'Илья Чибисов',
  //     organization: 'Центр детсткой неврологии, Тула',
  //     image: '/speakers/speaker_5.png',
  //   }],
  // },
  {
    id: 132,
    name: 'Пленарные заседания',
    location: 'Большой зал',
    is_coffee_break: false,
    subject: 'Каждый ребенок достоин семьи. Планы, Перспективы и Проекты Фонда. Планы, Перспективы и Проекты Фонда',
    date: '2021-09-10',
    start_at: '10:00',
    finish_at: '10:45',
    speakers: [{
      id: 12,
      full_name: 'Анастасия Залогина',
      organization: 'Президент фонда «Обнаженные сердца», Москва',
      image: '/speakers/speaker_avatar.png',
    },
    ],
  },
  {
    id: 134,
    name: 'Пленарные заседания',
    location: 'Большой зал',
    is_coffee_break: false,
    subject: 'Опыт пандемии глазами родителей',
    date: '2021-09-10',
    start_at: '10:45',
    finish_at: '11:50',
    speakers: [{
      id: 12,
      full_name: 'Анастасия Залогина',
      organization: 'Президент фонда «Обнаженные сердца», Москва',
      image: '/speakers/speaker_avatar.png',
    },
    ],
  },
  {
    id: 5,
    name: 'Обсуждение',
    location: 'Большой зал',
    is_coffee_break: false,
    subject: 'Эволюция системы воспитания в приёмных/замещающих семьях',
    date: '2021-09-10',
    start_at: '12:00',
    finish_at: '13:00',

    speakers: [{
      id: 4,
      full_name: 'Лейзл Шлебуш',
      organization: 'Университет Кейптауна, ЮАР',
      image: '/speakers/speaker_4.png',
    },],
  },
  {
    id: 6,
    name: 'секция 3',
    location: 'Большой зал',
    is_coffee_break: false,
    subject: 'Доказано эффективные программы раннего вмешательства для ключевых нарушений совместного внимания и игры у детей с РАС',
    date: '2021-09-10',
    start_at: '13:30',
    finish_at: '17:00',

    speakers: [{
      id: 12,
      full_name: 'Анастасия Залогина',
      organization: 'Президент фонда «Обнаженные сердца», Москва',
      image: '/speakers/speaker_avatar.png',
    },],
    speeches: [{
      id: 1,
      date: '2021-09-10',
      start_at: '12:00',
      finish_at: '13:00',
      subject: 'Каждый ребенок достоин семьи. Планы, Перспективы и Проекты Фонда',
      speakers: [{
        id: 12,
        full_name: 'Анастасия Залогина',
        organization: 'Президент фонда «Обнаженные сердца», Москва',
        image: '/speakers/speaker_avatar.png',
      },],
    }, {
      id: 2,
      date: '2021-09-10',
      start_at: '13:00',
      finish_at: '17:15',
      subject: 'Какие программы помощи для детей с РАС и особенностями развития на сегодняшний день являются доказано эффективными',
      speakers: [{
        id: 4,
        full_name: 'Лейзл Шлебуш',
        organization: 'Университет Кейптауна, ЮАР',
        image: '/speakers/speaker_4.png',
      },],
    }, {
      id: 3,
      date: '2021-09-10',
      start_at: '17:15',
      finish_at: '18:00',
      subject: 'Кофебрейк',
    },],
  },
  {
    id: 7,
    name: 'мастер-класс',
    location: 'Амфитеатр',
    is_coffee_break: false,
    subject: `Современные технологии обучения детей  с РАС в школе. Пятилетний опыт`,
    date: '2021-09-10',
    start_at: '12:00',
    finish_at: '13:00',

    speakers: [{
      id: 12,
      full_name: 'Анастасия Залогина',
      organization: 'Президент фонда «Обнаженные сердца», Москва',
      image: '/speakers/speaker_avatar.png',
    }, {
      id: 4,
      full_name: 'Лейзл Шлебуш',
      organization: 'Университет Кейптауна, ЮАР',
      image: '/speakers/speaker_4.png',
    },],
  },
  {
    id: 8,
    name: 'мастер-класс',
    location: 'Амфитеатр',
    is_coffee_break: false,
    subject: `Реализация программы «Ранняя Пташка». Факторы успешности`,
    date: '2021-09-10',
    start_at: '13:00',
    finish_at: '14:00',

    speakers: [{
      id: 4,
      full_name: 'Лейзл Шлебуш',
      organization: 'Университет Кейптауна, ЮАР',
      image: '/speakers/speaker_4.png',
    },],
  },
  {
    id: 2,
    name: '',
    location: 'Амфитеатр',
    is_coffee_break: true,
    subject: 'Кофебрейк',
    date: '2021-09-10',
    start_at: '16:10',
    finish_at: '18:00',
  },
  {
    id: 12,
    name: 'Обсуждение',
    location: 'малый зал',
    is_coffee_break: false,
    subject: `Эволюция системы воспитания в приёмных/замещающих семьях`,
    date: '2021-09-10',
    start_at: '11:00',
    finish_at: '11:30',

    speakers: [{
      id: 4,
      full_name: 'Лейзл Шлебуш',
      organization: 'Университет Кейптауна, ЮАР',
      image: '/speakers/speaker_4.png',
    },],
  },
  {
    id: 15,
    name: 'Обсуждение',
    location: 'малый зал',
    is_coffee_break: false,
    subject: `Эволюция системы воспитания в приёмных/замещающих семьях`,
    date: '2021-09-10',
    start_at: '11:30',
    finish_at: '12:00',

    speakers: [{
      id: 4,
      full_name: 'Лейзл Шлебуш',
      organization: 'Университет Кейптауна, ЮАР',
      image: '/speakers/speaker_4.png',
    },],
  },
];

const programSectionsDate2: ProgramSection[] = [
  {
    id: 1,
    name: 'Пленарные заседания',
    location: 'Выставочный зал',
    is_coffee_break: false,
    subject: 'Каждый ребенок достоин семьи. Планы, Перспективы и Проекты Фонда',
    date: '2021-09-11',
    start_at: '10:00',
    finish_at: '11:00',

    speakers: [{
      id: 12,
      full_name: 'Анастасия Залогина',
      organization: 'Президент фонда «Обнаженные сердца», Москва',
      image: '/speakers/speaker_avatar.png',
    },
    ],
  },
  {
    id: 2,
    name: '',
    location: 'Выставочный зал',
    is_coffee_break: true,
    subject: 'Кофебрейк',
    date: '2021-09-11',
    start_at: '11:00',
    finish_at: '12:00',
  },
  {
    id: 5,
    name: 'Обсуждение',
    location: 'Большой зал',
    is_coffee_break: false,
    subject: 'Эволюция системы воспитания в приёмных/замещающих семьях',
    date: '2021-09-11',
    start_at: '12:00',
    finish_at: '13:00',

    speakers: [{
      id: 4,
      full_name: 'Лейзл Шлебуш',
      organization: 'Университет Кейптауна, ЮАР',
      image: '/speakers/speaker_4.png',
    },],
  },
  {
    id: 6,
    name: 'секция 3',
    location: 'Большой зал',
    is_coffee_break: false,
    subject: 'Доказано эффективные программы раннего вмешательства для ключевых нарушений совместного внимания и игры у детей с РАС',
    date: '2021-09-11',
    start_at: '13:30',
    finish_at: '17:00',

    speakers: [{
      id: 12,
      full_name: 'Анастасия Залогина',
      organization: 'Президент фонда «Обнаженные сердца», Москва',
      image: '/speakers/speaker_avatar.png',
    },],
  },
  {
    id: 7,
    name: 'мастер-класс',
    location: 'Амфитеатр',
    is_coffee_break: false,
    subject: `Современные технологии обучения детей  с РАС в школе. Пятилетний опыт`,
    date: '2021-09-11',
    start_at: '12:00',
    finish_at: '13:00',

    speakers: [{
      id: 12,
      full_name: 'Анастасия Залогина',
      organization: 'Президент фонда «Обнаженные сердца», Москва',
      image: '/speakers/speaker_avatar.png',
    }, {
      id: 4,
      full_name: 'Лейзл Шлебуш',
      organization: 'Университет Кейптауна, ЮАР',
      image: '/speakers/speaker_4.png',
    },],
  },
  {
    id: 8,
    name: 'Обсуждение',
    location: 'малый зал',
    is_coffee_break: false,
    subject: `Эволюция системы воспитания в приёмных/замещающих семьях`,
    date: '2021-09-11',
    start_at: '11:00',
    finish_at: '12:00',

    speakers: [{
      id: 4,
      full_name: 'Лейзл Шлебуш',
      organization: 'Университет Кейптауна, ЮАР',
      image: '/speakers/speaker_4.png',
    },],
  },
];

export const program: Program = {
  id: 1,
  year: 2021,
  title: 'IX Международный форум \n«Обнажённые сердца»',
  title_en: 'IX Международный форум \n«Обнажённые сердца»',
  theme: `Переход во взрослую жизнь человека  с особенностями развития`,
  theme_en: `Переход во взрослую жизнь человека  с особенностями развития`,
  location: 'Центр «Особое детство»',
  location_en: 'Центр «Особое детство»',
  address: 'Москва, ул. Академика Королёва, 12',
  address_en: 'Москва, ул. Академика Королёва, 12',
  stream_link: 'https://www.youtube.com/watch?v=BwMiyPQLVsQ',
  main_video_link: 'https://www.youtube.com/watch?v=BwMiyPQLVsQ',
  main_video_preview: '/video_previews/main_page_top_video.png',
  dates: [
    { date: '2021-09-10', sections: programSections, },
    { date: '2021-09-11', sections: programSectionsDate2 },
    { date: '2021-09-12', sections: [] },
    { date: '2021-09-13', sections: [] },
    { date: '2021-09-14', sections: [] },
  ],
};

export const speakers: Speaker[] = [
  {
    id: 1,
    full_name: 'speaker 1',
    organization: '',
    image: '/speakers/speaker_1.png',
  },
  {
    id: 2,
    full_name: 'speaker 2',
    organization: '',
    image: '/speakers/speaker_2.png',
  },
  {
    id: 3,
    full_name: 'speaker 3',
    organization: '',
    location: 'Великий новгород, россия',
    description: `Телеведущий, спортсмен-паралимпиец и спикер. Он потерял ногу во время службы в ракетных войсках, но это не помешало ему жить полноценной жизнью, мечтать и добиваться поставленных целей. Его цель – донести аудитории, что сейчас происходит так называемый ребрендинг инвалидности и со стигматизацией людей с ограниченными возможностями нужно бороться. На своем опыте он показывает, что, несмотря на ограничения физических возможностей, каждый может продолжать жить полноценно`,
    image: '/speakers/speaker_3.png',
    tags: [{ name: 'ранний возраст' }, { name: 'Двигательные нарушения' }],
    link: 'https://nakedheart.online/experts',
  },
  {
    id: 4,
    full_name: 'Лейзл Шлебуш',
    organization: 'Университет Кейптауна, ЮАР',
    location: 'Кейптаун, Юар',
    description: `Лейзл Шлебуш получила докторскую степень (Ph.D) 
в области раннего вмешательства / альтернативной  и дополнительной коммуникации в Университете Претории  на факультете гуманитарных наук в Южной Африке.  В настоящее время она ведет лекции на отделении детской  и подростковой психиатрии в Университете Кейптауна,  а также работает координатором осуществления исследования и оценки на программе вмешательства  по обучению навыкам воспитывающего взрослого для семей, которые воспитывают детей с нарушениями развития: Южноафриканское пилотное исследование.`,
    image: '/speakers/speaker_4.png',
    tags: [{ name: 'ранний возраст' }, {
      name: 'Двигательные нарушения',
      link: 'https://nakedheart.online/experts'
    }, { name: 'Воспитание' }, { name: 'речь' }, { name: 'овз' }],
    link: 'https://nakedheart.online/experts',
  },
  {
    id: 5,
    full_name: 'Илья Чибисов',
    organization: 'Центр детсткой неврологии, Тула',
    image: '/speakers/speaker_5.png',
  },
];

export const forumData: ForumData = {
  program,
  about: {
    description: `Международный Форум «Обнажённые сердца» —  это редкая возможность для специалистов в области детского развития, родителей и общественных деятелей собраться за одним столом и на высоком профессиональном уровне обсудить проблемы работы с детьми и молодыми людьми с нарушениями развития, а также вопросы их интеграции в общество.`,
    description_en: `Международный Форум «Обнажённые сердца» —  это редкая возможность для специалистов в области детского развития, родителей и общественных деятелей собраться за одним столом и на высоком профессиональном уровне обсудить проблемы работы с детьми и молодыми людьми с нарушениями развития, а также вопросы их интеграции в общество.`,
    video_link: 'https://www.youtube.com/watch?v=BwMiyPQLVsQ',
    video_preview: '/video_previews/main_page_about_video.png',
    people_count: 5000,
    city_count: 150,
    country_count: 22,
  },
  speakers,
  partners: [
    { id: 1, logo: '/partners/partner1.png', link: 'https://www.youtube.com/watch?v=BwMiyPQLVsQ' },
    { id: 2, logo: '/partners/partner2.png', link: 'https://google.com' },
    { id: 3, logo: '/partners/partner3.png', link: 'https://www.youtube.com' },
    { id: 4, logo: '/partners/partner4.png', link: '' },
    { id: 5, logo: '/partners/partner5.png', link: '' },
  ],
};
export const yearTags: YearTag[] = [{ year: 2021 }, { year: 2020 }, { year: 2019 }, { year: 2018 }, { year: 2017 }, { year: 2016 }, { year: 2015 }, { year: 2014 }, { year: 2013 }];

export const signUpData: SignUpData = {
  with_accommodation_role1: '118079',
  without_accommodation_role1: '118079',
  with_accommodation_role2: '118079',
  without_accommodation_role2: '118079',
  steps: [
    {
      alias: 'terms',
      title: 'Условия участия',
      content: {
        content: '<p>Пожалуйста, ознакомьтесь с <a href="https://google.com" target="_blank" referrerpolicy="no-referrer">Условиями участия</a> перед тем, как заполнять анкету</p>',
      },
    },
    {
      alias: 'accommodation',
      title: 'Проживание',
      content: {
        content: `Проживание в отеле возможно строго в даты проведения Форума: с 14 по 16 октября 2019 года. Если Вы хотите заехать до 14 октября или уехать после 12:00 16 октября, Вы можете это сделать только за свой счет.

Большинство номеров, предоставляемых отелем под Форум, трехместные. Одноместные номера не предоставляются, поэтому специалисты одной организации не всегда будут расселятся вместе. В связи с большим количеством участников, Фонд не может рассмотреть индивидуальные заявки с просьбой разместить сотрудников в одном номере или переселить из одного номера в другой. Данные вопросы вне зоны наших возможностей.

Благодарим вас за понимание.`,
      },
    },
    {
      alias: 'role',
      title: 'Роль участника',
      content: { title: 'Роль участника форума', },
    },
  ],
};

export const archiveForums: ArchiveForumData = {
  results: [
    {
      year: 2020,
      title: 'VI Международный Форум «Каждый ребенок достоин семьи: Эффективные программы помощи»',
      description: 'Форум был посвящен невероятно важной, но редко обсуждаемой теме – методам с доказанной эффективностью.',
      dates: [{ date: '2020-09-10' }, { date: '2020-09-14' }],
      program: { description: 'ЛУЧШИЕ ПРАКТИКИ ПОВЕДЕНЧЕСКОГО ВМЕШАТЕЛЬСТВА ДЛЯ ДЕТЕЙ С НАРУШЕНИЯМИ ПОВЕДЕНИЯ и другие секции в программе VI форума «Обнажённые сердца» ' },
      speakers: { description: '55 специалистов из России, Великобритании, Чехии, Южной Африки и США' },
      videos: { link: 'https://google.com', description: 'Видеоматериалы прошлых форумов с 2012 года' },
    },
    {
      year: 2019,
      title: 'VI Международный Форум «Каждый ребенок достоин семьи: Эффективные программы помощи»',
      description: 'Форум был посвящен невероятно важной, но редко обсуждаемой теме – методам с доказанной эффективностью.',
      dates: [{ date: '2019-07-15' }, { date: '2019-07-24' }],
      program: { description: 'ЛУЧШИЕ ПРАКТИКИ ПОВЕДЕНЧЕСКОГО ВМЕШАТЕЛЬСТВА ДЛЯ ДЕТЕЙ С НАРУШЕНИЯМИ ПОВЕДЕНИЯ и другие секции в программе VI форума «Обнажённые сердца» ' },
      speakers: { description: '55 специалистов из России, Великобритании, Чехии, Южной Африки и США' },
      videos: { link: 'https://google.com', description: 'Видеоматериалы прошлых форумов с 2012 года' },
    },
    {
      year: 2018,
      title: 'VI Международный Форум «Каждый ребенок достоин семьи: Эффективные программы помощи»',
      description: 'Форум был посвящен невероятно важной, но редко обсуждаемой теме – методам с доказанной эффективностью.',
      dates: [{ date: '2018-09-10' }, { date: '2018-09-14' }],
      program: { description: 'ЛУЧШИЕ ПРАКТИКИ ПОВЕДЕНЧЕСКОГО ВМЕШАТЕЛЬСТВА ДЛЯ ДЕТЕЙ С НАРУШЕНИЯМИ ПОВЕДЕНИЯ и другие секции в программе VI форума «Обнажённые сердца» ' },
      speakers: { description: '55 специалистов из России, Великобритании, Чехии, Южной Африки и США' },
      videos: { link: 'https://google.com', description: 'Видеоматериалы прошлых форумов с 2012 года' },
    },
    {
      year: 2017,
      title: 'VI Международный Форум «Каждый ребенок достоин семьи: Эффективные программы помощи»',
      description: 'Форум был посвящен невероятно важной, но редко обсуждаемой теме – методам с доказанной эффективностью.',
      dates: [{ date: '2017-09-10' }, { date: '2017-09-14' }],
      program: { description: 'ЛУЧШИЕ ПРАКТИКИ ПОВЕДЕНЧЕСКОГО ВМЕШАТЕЛЬСТВА ДЛЯ ДЕТЕЙ С НАРУШЕНИЯМИ ПОВЕДЕНИЯ и другие секции в программе VI форума «Обнажённые сердца» ' },
      speakers: { description: '55 специалистов из России, Великобритании, Чехии, Южной Африки и США' },
      videos: { link: 'https://google.com', description: 'Видеоматериалы прошлых форумов с 2012 года' },
    },
    {
      year: 2016,
      title: 'VI Международный Форум «Каждый ребенок достоин семьи: Эффективные программы помощи»',
      description: 'Форум был посвящен невероятно важной, но редко обсуждаемой теме – методам с доказанной эффективностью.',
      dates: [{ date: '2016-09-10' }, { date: '2016-09-14' }],
      program: { description: 'ЛУЧШИЕ ПРАКТИКИ ПОВЕДЕНЧЕСКОГО ВМЕШАТЕЛЬСТВА ДЛЯ ДЕТЕЙ С НАРУШЕНИЯМИ ПОВЕДЕНИЯ и другие секции в программе VI форума «Обнажённые сердца» ' },
      speakers: { description: '55 специалистов из России, Великобритании, Чехии, Южной Африки и США' },
      videos: { link: 'https://google.com', description: 'Видеоматериалы прошлых форумов с 2012 года' },
    },
  ],
};

export const searchSuggestions: SearchSuggestion[] = ['двигательные нарушения', 'аутизм', 'синдром дауна', 'ранняя пташка'];

export const termsPage: DynamicPage = {
  title: 'Политика некоммерческой организации Фонд помощи детям и молодежи «Обнажённые сердца» в отношении обработки и защиты персональных данных',
  content: '<div class="_3j3bx _2zYE5 _2f6SI"><p><em>Редакция, действующая с 1 апреля 2020 года</em><br></p><h3>1. Общие положения</h3><p><strong>1.1.&nbsp;</strong>Настоящая политика в отношении Обработки и защиты персональных данных (далее – «<strong>Политика</strong>») утверждена некоммерческой организацией Фонд помощи детям и молодежи «Обнаженные сердца» (зарегистрированной на территории Российской Федерации, основной государственный регистрационный номер 1055238047072 от 20.04.2005 г., адрес места нахождения: 603005, Российская Федерация, Нижегородская обл., г. Нижний Новгород, ул. Пискунова, д. 10) (далее - «<strong>Фонд</strong>») и определяет основные принципы, цели, условия и способы Обработки персональных данных, перечни субъектов и обрабатываемых Фондом персональных данных, функции Фонда при Обработке персональных данных, права субъектов персональных данных, а также реализуемые в Фонде требования к защите персональных данных.</p><p><strong>1.2.&nbsp;</strong>Настоящая Политика разработана с учетом требований Конституции Российской Федерации (далее - <strong>«РФ»</strong>), Федерального закона от 27.07.2006 N 152-ФЗ «О персональных данных», а также иными законодательными и нормативно-правовыми актами РФ в области персональных данных.</p><p><strong>1.3.&nbsp;</strong>Настоящая Политика является основной для разработки локальных нормативных актов и других документов, регламентирующих Обработку персональных данных в Фонде.</p><p><strong>1.4.&nbsp;</strong>Фонд, являясь Оператором персональных данных, осуществляет Обработку персональных данных физических лиц (далее именуется - «<strong>Субъект персональных данных»</strong> или «<strong>Субъект</strong>») как состоящих, так и не состоящих с Фондом в трудовых отношениях, в частности, но не ограничиваясь:</p><ul><li>физических лиц, являющихся кандидатами на замещение вакантных должностей в Фонде или заключивших с Фондом трудовой договор (далее – «<strong>Работник</strong>» или «<strong>Работники</strong>»);</li><li>физических лиц, являющихся кандидатами на заключение или заключивших с Фондом гражданско-правовой договор на осуществление волонтерской деятельности (далее – «<strong>Волонтер</strong>» или «<strong>Волонтеры</strong>»);</li><li>физических лиц (в том числе физических лиц – представителей/работников юридических лиц) являющихся кандидатами на заключение или заключивших с Фондом гражданско-правовой договор, за исключением гражданско-правового договора на осуществление волонтерской деятельности;</li><li>иных физических лиц (в том числе физических лиц – представителей/работников юридических лиц), чьи персональные данные обрабатываются Фондом в связи с осуществлением Фондом своей уставной деятельности, в частности, но не ограничиваясь,&nbsp;физических лиц, принимающих участие в мероприятиях Фонда; физических лиц, направляющих в адрес Фонда предложения, заявления, жалобы в соответствии с Положением о порядке приема, регистрации и Обработки входящих обращений от третьих лиц в Фонд; иных физических лиц, предоставляющих свои персональные данные Фонду в ходе осуществления последним своей уставной деятельности и не подпадающих под действие иных локальных актов Фонда.</li></ul><p><strong>1.5.&nbsp;</strong>Правовым основанием Обработки персональных данных Фондом выступают, в частности, локальные нормативные акты Фонда, трудовые и гражданско-правовые договоры, заключаемые с Субъектами персональных данных, а также согласие Субъектов на Обработку их персональных данных.</p><p><strong>1.6.&nbsp;</strong>Политика принимается Фондом также в целях обеспечения защиты прав и свобод человека и гражданина при Обработке его персональных данных, в том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну.</p><h3>2.&nbsp;Основные термины и определения</h3><p><strong>2.1.&nbsp;</strong>Для целей настоящей Политики используются следующие основные понятия:</p><p><strong>2.1.1.&nbsp;&nbsp;&nbsp;&nbsp;</strong>Персональные данные - любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу – Субъекту персональных данных;</p><p><strong>2.1.2.&nbsp;&nbsp;&nbsp;&nbsp;</strong>Оператор - государственный орган, муниципальный орган, юридическое или физическое лицо, самостоятельно ил совместно с другими лицами организующие и (или) осуществляющие Обработку персональных данных, а также определяющие цели Обработки персональных данных, состав персональных данных, подлежащих Обработке, действия (операции), совершаемые с персональными данными;</p><p><strong>2.1.3.&nbsp;&nbsp;&nbsp;&nbsp;</strong>Обработка персональных данных - любое действие (операция) или совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (Распространение, Предоставление, доступ), Обезличивание, Блокирование, удаление, уничтожение персональных данных;</p><p><strong>2.1.4.&nbsp;&nbsp;&nbsp;&nbsp;</strong>Ответственный за организацию Обработки – лицо, назначенное приказом ответственным за организацию Обработки Персональных данных;</p><p><strong>2.1.5.&nbsp;&nbsp;&nbsp;&nbsp;</strong>Автоматизированная Обработка персональных данных - Обработка персональных данных с помощью средств вычислительной техники;</p><p><strong>2.1.6.&nbsp;&nbsp;&nbsp;&nbsp;</strong>Распространение персональных данных - действия, направленные на раскрытие персональных данных неопределенному кругу лиц;</p><p><strong>2.1.7.&nbsp;&nbsp;&nbsp;&nbsp;</strong>Предоставление персональных данных - действия, направленные на раскрытие персональных данных определенному лицу или определенному кругу лиц;</p><p><strong>2.1.8.&nbsp;&nbsp;&nbsp;&nbsp;</strong>Блокирование персональных данных - временное прекращение Обработки персональных данных (за исключением случаев, если Обработка необходима для уточнения персональных данных);</p><p><strong>2.1.9.&nbsp;&nbsp;&nbsp;&nbsp;</strong>Уничтожение персональных данных - действия, в результате которых становится невозможным восстановить содержание персональных данных в информационной системе персональных данных и (или) в результате которых уничтожаются материальные носители персональных данных;</p><p><strong>2.1.10.&nbsp;</strong>Обезличивание персональных данных - действия, в результате которых становится невозможным без использования дополнительной информации определить принадлежность персональных данных конкретному Субъекту персональных данных;</p><p><strong>2.1.11.&nbsp;</strong>Трансграничная передача персональных данных - передача персональных данных на территорию иностранного государства органу власти иностранного государства, иностранному физическому лицу или иностранному юридическому лицу.</p></div>',
};

export const newsList: News[] = [
  {
    id: 1,
    title: "VIII Международный Форум «Каждый ребёнок достоин семьи» собрал более 500 участников",
    is_main: true,
    has_video: true,
    published_at: "2021-10-07T14:28:34Z",
    head_image: { image: "/video_previews/main_page_about_video.png" },
    lead: `В этом году Форум был посвящен качеству жизни людей  с особенностями развития. Мероприятие собрало 517 участников из 66 городов России и ближнего зарубежья. Церемонию открытия провела актриса, телеведущая, член попечительского совета благотворительного фонда «Созидание» Татьяна Лазарева.`,
    blocks: [
      {
        id: 1,
        kind: 'text',
        text: "<p><span style=\"white-space:pre-wrap;\">В течение трех дней работы Форума его участники вместе с ведущими международными и российскими экспертами обсуждали составляющие качества жизни людей с особенностями развития и современные программы помощи, которые смогут эффективно его улучшить для семей, воспитывающих детей с ментальной и физической инвалидностью.<br><br>С 2012 года форум является площадкой не только для развития профессионального сообщества, но и для повышения информированности общества о различных особенностях развития, таких как аутизм, церебральный паралич, синдром Дауна, множественные нарушения и др. В рамках параллельной программы форума основатель Фонда «Обнаженные сердца» Наталья Водянова вместе с телеведущей Первого канала Ольгой Ушаковой обсудили различные аспекты качества жизни людей с нарушениями в развитии.</span><span style=\"white-space:pre-wrap;\"><br></span></p>"
      },
      {
        id: 2,
        kind: 'quote',
        text: 'Качество жизни для людей с особенностями развития — это просто возможность жить нормальной жизнью. Мы в Фонде «Обнаженные сердца» помогаем семьям, воспитывающим детей с аутизмом и другими нарушениями в развитии, реализовать право на нормальную жизнь: для этого мы готовим специалистов, которые оказывают квалифицированные программы помощи, обучаем родителей, развиваем центры поддержки семьи. И одним из важнейших шагов в этом направлении — проведение ежегодного международного форума «Каждый ребенок достоин семьи',
      }
    ]
  },
  {
    id: 2,
    title: "Сотни специалистов из восьми стран приняли участие в VII Международном Форуме «Каждый ребёнок достоин семьи»",
    is_main: false,
    published_at: "2021-10-07T14:34:12Z",
    head_image: { image: "/video_previews/main_page_top_video.png" },
    blocks: [
      {
        id: 1,
        kind: 'text',
        text: "<p><span style=\"white-space:pre-wrap;\">В течение трех дней работы Форума его участники вместе с ведущими международными и российскими экспертами обсуждали составляющие качества жизни людей с особенностями развития и современные программы помощи, которые смогут эффективно его улучшить для семей, воспитывающих детей с ментальной и физической инвалидностью.<br><br>С 2012 года форум является площадкой не только для развития профессионального сообщества, но и для повышения информированности общества о различных особенностях развития, таких как аутизм, церебральный паралич, синдром Дауна, множественные нарушения и др. В рамках параллельной программы форума основатель Фонда «Обнаженные сердца» Наталья Водянова вместе с телеведущей Первого канала Ольгой Ушаковой обсудили различные аспекты качества жизни людей с нарушениями в развитии.</span></p>",
      }
    ]
  },
  {
    id: 3,
    title: "VIII Международный Форум «Каждый ребёнок достоин семьи» собрал более 500 участников",
    is_main: false,
    has_video: true,
    published_at: "2021-10-07T14:28:34Z",
    head_image: { image: "/speakers/speaker_3.png" },
    blocks: [
      {
        id: 1,
        kind: 'text',
        text: "<p><span style=\"white-space:pre-wrap;\">В течение трех дней работы Форума его участники вместе с ведущими международными и российскими экспертами обсуждали составляющие качества жизни людей с особенностями развития и современные программы помощи, которые смогут эффективно его улучшить для семей, воспитывающих детей с ментальной и физической инвалидностью.<br><br>С 2012 года форум является площадкой не только для развития профессионального сообщества, но и для повышения информированности общества о различных особенностях развития, таких как аутизм, церебральный паралич, синдром Дауна, множественные нарушения и др. В рамках параллельной программы форума основатель Фонда «Обнаженные сердца» Наталья Водянова вместе с телеведущей Первого канала Ольгой Ушаковой обсудили различные аспекты качества жизни людей с нарушениями в развитии.</span><span style=\"white-space:pre-wrap;\"><br></span></p>"
      }
    ]
  },
  {
    id: 4,
    title: "Сотни специалистов из восьми стран приняли участие в VII Международном Форуме «Каждый ребёнок достоин семьи»",
    is_main: false,
    published_at: "2021-10-07T14:34:12Z",
    head_image: { image: "/speakers/speaker_4.png" },
    blocks: [
      {
        id: 1,
        kind: 'text',
        text: "<p><span style=\"white-space:pre-wrap;\">В течение трех дней работы Форума его участники вместе с ведущими международными и российскими экспертами обсуждали составляющие качества жизни людей с особенностями развития и современные программы помощи, которые смогут эффективно его улучшить для семей, воспитывающих детей с ментальной и физической инвалидностью.<br><br>С 2012 года форум является площадкой не только для развития профессионального сообщества, но и для повышения информированности общества о различных особенностях развития, таких как аутизм, церебральный паралич, синдром Дауна, множественные нарушения и др. В рамках параллельной программы форума основатель Фонда «Обнаженные сердца» Наталья Водянова вместе с телеведущей Первого канала Ольгой Ушаковой обсудили различные аспекты качества жизни людей с нарушениями в развитии.</span></p>",
      }
    ]
  },
  {
    id: 5,
    title: "VIII Международный Форум «Каждый ребёнок достоин семьи» собрал более 500 участников",
    is_main: false,
    published_at: "2021-10-07T14:28:34Z",
    head_image: { image: "/speakers/speaker_5.png" },
    blocks: [
      {
        id: 1,
        kind: 'text',
        text: "<p><span style=\"white-space:pre-wrap;\">В течение трех дней работы Форума его участники вместе с ведущими международными и российскими экспертами обсуждали составляющие качества жизни людей с особенностями развития и современные программы помощи, которые смогут эффективно его улучшить для семей, воспитывающих детей с ментальной и физической инвалидностью.<br><br>С 2012 года форум является площадкой не только для развития профессионального сообщества, но и для повышения информированности общества о различных особенностях развития, таких как аутизм, церебральный паралич, синдром Дауна, множественные нарушения и др. В рамках параллельной программы форума основатель Фонда «Обнаженные сердца» Наталья Водянова вместе с телеведущей Первого канала Ольгой Ушаковой обсудили различные аспекты качества жизни людей с нарушениями в развитии.</span><span style=\"white-space:pre-wrap;\"><br></span></p>"
      }
    ]
  },
  {
    id: 6,
    title: "Сотни специалистов из восьми стран приняли участие в VII Международном Форуме «Каждый ребёнок достоин семьи»",
    is_main: false,
    published_at: "2021-10-07T14:34:12Z",
    head_image: { image: "/speakers/speaker_1.png" },
    blocks: [
      {
        id: 1,
        kind: 'text',
        text: "<p><span style=\"white-space:pre-wrap;\">В течение трех дней работы Форума его участники вместе с ведущими международными и российскими экспертами обсуждали составляющие качества жизни людей с особенностями развития и современные программы помощи, которые смогут эффективно его улучшить для семей, воспитывающих детей с ментальной и физической инвалидностью.<br><br>С 2012 года форум является площадкой не только для развития профессионального сообщества, но и для повышения информированности общества о различных особенностях развития, таких как аутизм, церебральный паралич, синдром Дауна, множественные нарушения и др. В рамках параллельной программы форума основатель Фонда «Обнаженные сердца» Наталья Водянова вместе с телеведущей Первого канала Ольгой Ушаковой обсудили различные аспекты качества жизни людей с нарушениями в развитии.</span></p>",
      }
    ]
  },
];

export const galleryList: GalleryImage[] = [
  {
    id: 1,
    image: '/video_previews/main_page_about_video.png',
  },
  {
    id: 2,
    image: '/video_previews/main_page_top_video.png',
  },
  {
    id: 3,
    image: '/speakers/speaker_3.png',
  },
  {
    id: 4,
    image: '/speakers/speaker_4.png',
  },
  {
    id: 5,
    image: '/speakers/speaker_5.png',
  },
  {
    id: 6,
    image: '/speakers/speaker_1.png',
  },
  {
    id: 7,
    image: '/speakers/speaker_2.png',
  },
];

// export const galleryList: GalleryImage[] = [
//   {
//     id: 1,
//     image: 'https://picsum.photos/400/300.webp?random=1',
//   },
//   {
//     id: 2,
//     image: 'https://picsum.photos/400/300.webp?random=2',
//   },
//   {
//     id: 3,
//     image: 'https://picsum.photos/400/300.webp?random=3',
//   },
//   {
//     id: 4,
//     image: 'https://picsum.photos/400/300.webp?random=4',
//   },
//   {
//     id: 5,
//     image: 'https://picsum.photos/400/300.webp?random=5',
//   },
//   {
//     id: 6,
//     image: 'https://picsum.photos/400/300.webp?random=6',
//   },
//   {
//     id: 7,
//     image: 'https://picsum.photos/400/300.webp?random=7',
//   },
// ];
